export const processCelery = (state, action, data) => {
    return {
        data: data,
        taskMapping: Object.fromEntries(new Map(data.map((obj) => [obj.task_id, obj]))),
    };
};
